/* eslint-disable import/prefer-default-export */
import * as Sentry from "@sentry/react";
import CurrentUser from "../apiResources/CurrentUser";
import EmployerMembership from "../apiResources/EmployerMembership";
import { LOAD_PREMIUM_PRICING, LOAD_PREMIUM_PRICING_ERROR } from "./types";

export const loadPremiumPricing = () => async (dispatch) => {
  try {
    const currentUser = await CurrentUser.first();
    const membership = await EmployerMembership.order({ created_at: "desc" })
      .per(1)
      .all();

    dispatch({
      type: LOAD_PREMIUM_PRICING,
      payload: {
        employerId: parseInt(currentUser.data.companyId, 10),
        employerMembership: membership.data[0],
      },
    });
  } catch (error) {
    Sentry.captureException(error);

    dispatch({
      type: LOAD_PREMIUM_PRICING_ERROR,
      payload: error,
    });
  }
};
